import { computed } from 'vue';

import { useUserStore } from '../store/user';

export function useAvatar() {
  const userStore = useUserStore();

  const label = computed(() => {
    if (!userStore.user) {
      return 'A';
    }

    const firstLetter = userStore.user.first_name.charAt(0);
    const secondLetter = userStore.user.last_name.charAt(0);

    return `${firstLetter}${secondLetter}`;
  });

  return { label };
}
